// Constants for CME Forex Futures tick sizes and tick values
const forexFutures = {
    "EUR/USD": {
      tickSize: 0.00005, // Minimum price fluctuation
      tickValue: 6.25,   // Tick value in USD
    },
    "GBP/USD": {
      tickSize: 0.00005, 
      tickValue: 6.25,
    },
    "AUD/USD": {
      tickSize: 0.00005,
      tickValue: 5.00,
    },
    "BRL/USD": {
      tickSize: 0.00005,
      tickValue: 5.00,
    },
    "NZD/USD": {
      tickSize: 0.00005,
      tickValue: 5.00,
    },
    "USD/JPY": {
      tickSize: 0.005,
      tickValue: 6.25,
    },
    "USD/CHF": {
      tickSize: 0.0001,
      tickValue: 12.50,
    },
    "CAD/USD": {
      tickSize: 0.0001,
      tickValue: 10.00,
    },
    "EUR/GBP": {
      tickSize: 0.00001,
      tickValue: 6.25,
    },
    "EUR/JPY": {
      tickSize: 0.005,
      tickValue: 6.25,
    },
    "GBP/JPY": {
      tickSize: 0.01,
      tickValue: 12.50,
    },
    "AUD/JPY": {
      tickSize: 0.005,
      tickValue: 5.00,
    },
    "EUR/AUD": {
      tickSize: 0.0001,
      tickValue: 10.00,
    },
    "MXN/USD": {
      tickSize: 0.00001,
      tickValue: 5.00,
    },
  };
  
  export default forexFutures;
  